/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { PATCH } from "../../../services/AxiosService";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [validated, setValidated] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  // show/hide states for eye toggle
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // Password complexity regex
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{|":?><`]).{8,20}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedForm);

    const { oldPassword, newPassword, confirmPassword } = updatedForm;

    // validation
    let passwordValid = passwordRegex.test(newPassword);
    let confirmValid = newPassword === confirmPassword;

    if (!newPassword) {
      setPasswordError("Password baru wajib diisi.");
      passwordValid = false;
    } else if (!passwordValid) {
      setPasswordError(
        "Password harus 8–20 karakter, mengandung huruf besar, huruf kecil, angka, dan simbol."
      );
    } else {
      setPasswordError("");
    }

    const isValid = oldPassword.length > 0 && passwordValid && confirmValid;
    setValidated(isValid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Apakah Anda yakin ingin mengubah password?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5932EA",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const res = await PATCH("user/me/change-password", {
          old_password: formData.oldPassword,
          new_password: formData.newPassword,
          password_confirmation: formData.confirmPassword,
        });

        if (res) {
          Swal.fire({
            icon: "success",
            title: "Password berhasil diperbarui!",
          });
          setFormData({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          setValidated(false);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal memperbarui password",
          text: error?.response?.data?.message || "Terjadi kesalahan",
        });
      }
    }
  };

  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Ganti Password</Card.Title>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  {/* Old Password */}
                  <Col xl={4}>
                    <Form.Group>
                      <Form.Label>Password Lama</Form.Label>
                      <div className="position-relative" style={{ marginBottom: "0.5rem" }}>
                        <Form.Control
                          type={showOld ? "text" : "password"}
                          name="oldPassword"
                          value={formData.oldPassword}
                          onChange={handleChange}
                          required
                          style={{ paddingRight: "2.5rem" }}
                        />
                        <span
                          onClick={() => setShowOld(!showOld)}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                          }}
                        >
                          {showOld ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* New Password */}
                  <Col xl={4}>
                    <Form.Group>
                      <Form.Label>Password Baru</Form.Label>
                      <div className="position-relative" style={{ marginBottom: "0.5rem" }}>
                        <Form.Control
                          type={showNew ? "text" : "password"}
                          name="newPassword"
                          value={formData.newPassword}
                          onChange={handleChange}
                          isInvalid={!!formData.newPassword && !!passwordError}
                          required
                          minLength={8}
                          maxLength={20}
                          style={{
                            paddingRight: "2.5rem",
                            backgroundImage: "none", // 🚀 remove bootstrap validation icon
                          }}
                        />
                        <span
                          onClick={() => setShowNew(!showNew)}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                          }}
                        >
                          {showNew ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                      {/* error placed OUTSIDE wrapper so eye icon never moves */}
                      {passwordError && (
                        <div className="invalid-feedback d-block">{passwordError}</div>
                      )}
                      <small className="text-muted">
                        8–20 karakter, harus mengandung huruf besar, huruf kecil,
                        angka, dan simbol.
                      </small>
                    </Form.Group>
                  </Col>

                  {/* Confirm Password */}
                  <Col xl={4}>
                    <Form.Group>
                      <Form.Label>Konfirmasi Password Baru</Form.Label>
                      <div className="position-relative" style={{ marginBottom: "0.5rem" }}>
                        <Form.Control
                          type={showConfirm ? "text" : "password"}
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          isInvalid={
                            formData.confirmPassword &&
                            formData.confirmPassword !== formData.newPassword
                          }
                          required
                          minLength={8}
                          maxLength={20}
                          style={{
                            paddingRight: "2.5rem",
                            backgroundImage: "none", // 🚀 remove bootstrap validation icon
                          }}
                        />
                        <span
                          onClick={() => setShowConfirm(!showConfirm)}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                          }}
                        >
                          {showConfirm ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                      {formData.confirmPassword &&
                        formData.confirmPassword !== formData.newPassword && (
                          <div className="invalid-feedback d-block">
                            Konfirmasi password harus sama dengan password baru.
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!validated}
                  >
                    Simpan Perubahan
                  </button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ChangePassword;
